module.exports = __webpack_public_path__ + "stride3d.97a1af.svg";